import moment from "moment-timezone";

/**
 * Compact "time since" label for the conversation-list rows ("Now", "2 mins",
 * "1 hr", "3 days", then a short date for older). Kept terse to fit the row's
 * right-aligned meta slot, unlike moment's verbose `fromNow()`.
 */
export function timeSince(iso: string | null | undefined): string {
  if (!iso) return "";
  // The API sends this timestamp as a naive UTC string (no offset), so parse it
  // as UTC, then view it locally — the relative label and the >1-week date
  // fallback both reflect the viewer's clock (matching MessageBubble /
  // groupMessagesByDay). Parsing with plain moment(iso) would read it as local
  // and skew every "time since" by the viewer's UTC offset.
  const then = moment.utc(iso).local();
  if (!then.isValid()) return "";
  const now = moment();
  const seconds = now.diff(then, "seconds");
  if (seconds < 45) return "Now";
  const minutes = now.diff(then, "minutes");
  if (minutes < 60) return `${minutes} min${minutes === 1 ? "" : "s"}`;
  const hours = now.diff(then, "hours");
  if (hours < 24) return `${hours} hr${hours === 1 ? "" : "s"}`;
  const days = now.diff(then, "days");
  if (days < 7) return `${days} day${days === 1 ? "" : "s"}`;
  // Older than a week: a short calendar date (omit the year if it's this year).
  return then.year() === now.year()
    ? then.format("MMM D")
    : then.format("MMM D, YYYY");
}
